import { Color, withCitrusTheme } from '@gousto-internal/citrus-react';
import Image from 'next/image';
import { HOME_REDESIGN_BREAKPOINT, RADIUS_MD } from '../HomeRedesign/tokens';
import { FullBleedRailWrap } from '../HomeRedesign/FullBleedRailWrap/FullBleedRailWrap';
import { Rail } from '../HomeRedesign/Rail';
import { COLLECTIONS } from './collections.data';

const RailArea = withCitrusTheme('div', () => ({
  gridArea: 'rail',
  position: 'relative',
  minWidth: 0,
  alignSelf: 'center',
}));

const SCROLLER_STYLE = { paddingTop: '8px', paddingBottom: '8px', paddingRight: '24px' };
const TRACK_STYLE = { gap: '16px' };

const CollectionTile = withCitrusTheme('li', (theme) => ({
  position: 'relative',
  flex: '0 0 auto',
  width: '220px',
  height: '320px',
  overflow: 'hidden',
  borderRadius: RADIUS_MD,
  backgroundColor: theme.color(Color.ColdGrey_800),
  scrollSnapAlign: 'start',
  [`@media (min-width: ${HOME_REDESIGN_BREAKPOINT})`]: {
    width: '230px',
    height: '360px',
    scrollSnapAlign: 'none',
  },
}));

const TileScrim = withCitrusTheme('div', () => ({
  position: 'absolute',
  inset: 0,
  background: 'linear-gradient(180deg, rgba(33,41,48,0) 40%, rgba(0,0,0,0.8) 87%)',
}));

const TileLabel = withCitrusTheme('p', (theme) => ({
  position: 'absolute',
  left: theme.spacing(4),
  right: theme.spacing(4),
  bottom: theme.spacing(8),
  margin: 0,
  color: theme.color(Color.White),
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '28px',
}));

export function CollectionsRail(): JSX.Element {
  return (
    <RailArea>
      <FullBleedRailWrap
        paddingLeftMobile={4}
        paddingRightMobile={0}
        paddingLeftDesktop={0}
        paddingRightDesktop={0}
      >
        <Rail
          ariaLabel="Weekly collections"
          trackAs="ul"
          showArrows
          scrollSnap
          edgeFade="none"
          scrollerStyle={SCROLLER_STYLE}
          trackStyle={TRACK_STYLE}
        >
          {COLLECTIONS.map((collection) => (
            <CollectionTile key={collection.label}>
              <Image
                src={collection.image}
                alt={collection.imageAlt}
                fill
                sizes="(min-width: 820px) 230px, 220px"
                style={{ objectFit: 'cover' }}
              />
              <TileScrim />
              <TileLabel>{collection.label}</TileLabel>
            </CollectionTile>
          ))}
        </Rail>
      </FullBleedRailWrap>
    </RailArea>
  );
}
